import { useLanguage } from "@/i18n/LanguageContext";

const styles = {
  prototype: "bg-emerald-500/10 text-emerald-800 border-emerald-500/40",
  development: "bg-amber-500/10 text-amber-800 border-amber-500/40",
  concept: "bg-slate-500/10 text-slate-700 border-slate-500/40",
};

const stylesDark = {
  prototype: "bg-emerald-400/10 text-emerald-300 border-emerald-400/40",
  development: "bg-amber-400/10 text-amber-300 border-amber-400/40",
  concept: "bg-slate-400/10 text-slate-300 border-slate-400/40",
};

const dots = {
  prototype: "bg-emerald-500",
  development: "bg-amber-500",
  concept: "bg-slate-400",
};

export function MaturityBadge({ status, testId, onDark = false }) {
  const { t } = useLanguage();
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-mono font-semibold uppercase tracking-wider border ${(onDark ? stylesDark : styles)[status]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dots[status]}`} aria-hidden="true" />
      {t.common.status[status]}
    </span>
  );
}
